import instance from "../../../../shared/components/auth/service/AxiosInstance"

export const LaundryItemService = {
    getLaundryItems: (pageNo, pageSize) => 
        instance.get(process.env.REACT_APP_API_URL + 'laundry/' +
            '?pageSize=' + pageSize +
            '&pageNo=' + pageNo,
        ),
}